import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Parallax from './parallax';
import backgroundImage from './assets/background_reech_converted.png';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const Index = () => {
  return (
    <div>
      <Parallax backgroundImage={backgroundImage}>
        <h1>Protarget Group LLC</h1>
        <h2>Your customer's passion</h2>
      </Parallax>
    </div>
  );
};

export default Index;

